<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="700">
    <v-card height="400">
      <v-card-title class="justify-space-between pa-4">
        <v-btn icon disabled small><v-icon>mdi-clear</v-icon></v-btn>
        <span class="font-26" style="color: #00a99d; font-weight: bold"
          >Generate QR Code
        </span>
        <v-btn icon color="#00a99d" @click="closeBtn" small
          ><v-icon>mdi-close</v-icon></v-btn
        >
        
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" lg="6" md="6" sm="6">
            <div class="d-flex align-center pb-3">
              <v-icon class="pr-2" color="#00a99d">mdi-account</v-icon>
              <span class="font-16"
                >{{ itemQr.account_title_th ? itemQr.account_title_th : "-" }} {{ itemQr.first_name_th }}
                {{ itemQr.last_name_th }}</span
              >
            </div>
            <div class="d-flex align-center pb-3">
              <v-icon class="pr-2" color="#00a99d"
                >mdi-card-account-details</v-icon
              >
              <span class="font-16">{{ displayItem("old") }}</span>
            </div>
            <div class="d-flex align-center pb-3">
              <v-icon class="pr-2" color="#00a99d">mdi-gender-male</v-icon>
              <span class="font-16">{{ displayItem("gender") }}</span>
            </div>
            <div class="d-flex align-center pb-3">
              <v-icon class="pr-2" color="#00a99d">mdi-cellphone </v-icon>
              <span class="font-16">{{ displayItem("phone") }}</span>
            </div>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="6" align-self="center" align="center">
            <qrcode
              class="d-flex flex-column justify-center align-center"
              :text="qrCodeValue"
              v-if="qrCodeValue != ''"
            ></qrcode>

            <v-progress-circular
              v-else
              :size="50"
              :width="5"
              color="#00a99d"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import Qrcode from "vue-qrcode-component";

export default {
  components: {
    Qrcode,
  },
  data() {
    return {
      dialog: false,
      itemQr: {},
      qrCodeValue: "",
      search: "",
      status: true,
    };
  },
  methods: {
    async open(item) {
      this.itemQr = {};
      this.qrCodeValue = "";
      await this.getQRCODE_userqrid(item.userqr_id);
      this.dialog = true;
    },
    async getQRCODE(cid) {
      try {
        const params = new URLSearchParams();
        params.append("cid", cid);
        params.append("biz_id", sessionStorage.biz_id);
        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/get_bycid?${params}`
        );
        if (result == "success") {
          if (data) {
            this.itemQr = data;
            const { data: { data: dataQR } = {} } = await this.axios.post(
              `${process.env.VUE_APP_BACKEND_URL}/v1/user-qr`,
              {
                cid: data.cid,
                biz_id: sessionStorage.biz_id
              }
            );
            this.qrCodeValue = dataQR;
          }
        }
      } catch (error) {
        console.error();
      }
    },
    async getQRCODE_userqrid(user_id) {
      try {
        const params = new URLSearchParams();
        params.append("userqr_id", user_id);
        const { data: { data, result,url_qrcode } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/genurl_qrcode?${params}`
        );
        if (result == "success") {
          if (data) {
            this.itemQr = data;

            setTimeout(() => {
              this.qrCodeValue = url_qrcode;
            }, 1500);

          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // async getQRCODE(cid) {
    //   try {
    //     const params = new URLSearchParams();
    //     params.append("cid", cid);
    //     params.append("biz_id", sessionStorage.biz_id);
    //     const { data: { data, result } = {} } = await this.axios.get(
    //       `${process.env.VUE_APP_BACKEND_URL}/get_bycid?${params}`
    //     );
    //     if (result == "success") {
    //       if (data) {
    //         this.itemQr = data;
    //       }
    //     }
    //   } catch (error) {
    //     console.error();
    //   }
    // },
    // async searchQR(search) {
    //   const data = functioncryto.encrypt(search);
    //   if (this.itemQr.cid == data) {
    //     try {
    //       const { data: { data: dataQR } = {} } = await this.axios.post(
    //         `${process.env.VUE_APP_BACKEND_URL}/v1/user-qr`,
    //         {
    //           cid: data,
    //         }
    //       );
    //       this.qrCodeValue = dataQR;
    //       this.status = true;
    //     } catch (error) {
    //       console.error();
    //     }
    //   } else {
    //     this.qrCodeValue = "";
    //     this.status = false;
    //   }
    // },
    displayItem(type) {
      const { itemQr: { account_title_th, birth_date, mobile } = {} } = this;

      switch (type) {
        case "gender":
          if (account_title_th) {
            if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
            if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
              return "หญิง";
          } else if (account_title_th == null) {
            return "-";
          }

          break;

        case "old":
          if (birth_date) {
            const y = Math.floor(
              moment.duration(moment().diff(birth_date)).asYears()
            );
            return y;
          } else if (birth_date == null) {
            return "-";
          }

          break;

        case "phone":
          if (mobile) {
            return mobile;
          } else if (mobile == null) {
            return "-";
          }

          break;
      }
    },
    closeBtn() {
      this.itemQr = {};
      this.qrCodeValue = "";
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 8px 8px 0 0;
  box-shadow: none;
}
</style>
